const classes = {
  icon: {
    fontSize: 35,
    color: 'primary.main',
    mt: '2px',
  },
};

export default classes;
